<template>
<div class="height-100">
  <router-view v-if="isRouterAlive"></router-view>
</div>
</template>

<script>
export default {
  name: "SettingIndex",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style scoped>

</style>
